// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b87f57ba","644":"f10c06e4","732":"f1684fdb"}[chunkId] + ".chunk.js";
};